import React from 'react';
import { properties } from '../../../data/mockData';
import { PropertyCard } from '../../../components/shared/PropertyCard';
export const SavedProperties = () => {
  const saved = properties.slice(0, 4);
  return <div className="space-y-6 animate-in fade-in" data-id="element-1331">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-1332">
        <div data-id="element-1333">
          <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1334">
            Saved Properties
          </h1>
          <p className="text-text-light" data-id="element-1335">
            Properties you've favorited for later.
          </p>
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-2 custom-scrollbar" data-id="element-1336">
        <button className="px-4 py-2 rounded-lg bg-primary-900 text-white text-sm font-bold whitespace-nowrap" data-id="element-1337">
          All Saved (4)
        </button>
        <button className="px-4 py-2 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1338">
          Tier 1 (2)
        </button>
        <button className="px-4 py-2 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1339">
          Tier 2 (1)
        </button>
        <button className="px-4 py-2 rounded-lg bg-white border border-neutral-200 text-text text-sm font-medium hover:bg-neutral-50 whitespace-nowrap" data-id="element-1340">
          Tier 3 (1)
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-id="element-1341">
        {saved.map(p => <PropertyCard key={p.id} property={p} data-id="element-1342" />)}
      </div>
    </div>;
};